broadcastWatches